import {get} from '@assets/js/imaios-global/imaios-global';

export function initReportForm() {
	/**
	 * This controls the popup and form used to report errors on a structure page.
	 */
	function nextFrame(cb) {
		if (requestAnimationFrame) {
			requestAnimationFrame(cb);
		} else {
			cb();
		}
	}

	function afterNextFrame() {
		return new Promise(resolve => {
			nextFrame(() => {
				resolve();
			})
		});
	}

	const elemFormErrorHashId = document.getElementById('structureSendErrorForm_hash');

	function hashErrorToSend() {
		// fill the hash on the secureForm
		elemFormErrorHashId.value = get('currentHash');
	}

	const buttonCancelErrorForm = document.getElementById("button-definitionError-cancel");
	const popupContainer = document.getElementById('popup-alert-description');

	async function execInlineJS(rawHtmlText) {
		const parser = new DOMParser();
		const html = parser.parseFromString(rawHtmlText, 'text/html');
		const scripts = Array.from(html.querySelectorAll('script'));
		for (const script of scripts) {
			const s = document.createElement('script');
			s.innerHTML = script.innerHTML;
			document.body.appendChild(s);
		}
	}

	document
		.getElementById('errorButtonModal')?.addEventListener("click", async () => {
		const ImaiosForm = (await import('@assets/js/imaios-form/imaios-form.model.js')).default;
		new ImaiosForm({
			element: 'structureSendErrorForm',
			onsubmit: imaiosForm => {
				fetch(imaiosForm.form.action, imaiosForm.form.options)
					.then(response => response.text())
					.then(data => {
						popupContainer.innerHTML = data;
						buttonCancelErrorForm.click();

						// we have to wait until next rendering to be sure that previous modal is closed
						afterNextFrame().then(() => {
							execInlineJS(data);
						});
					})
					.catch(error => {
						console.error(error);
						window.NREUM?.noticeError(error);
					})
			}
		});
		hashErrorToSend()
	});
}

initReportForm();
